<script setup>
  import ListeAffaires from '@/components/ListeAffaires.vue'

</script>

<template>
  <h1>Liste des affaires</h1>
  <div class="affaires">
    <ListeAffaires/>
  </div>
</template>

<script>


export default {

}
</script>

<style>


</style>
